import { WeekDays } from "../constants";
import { WorkingHours } from "../features/restaurant/restaurantModels";
import { format } from "date-fns";
import moment from "moment-timezone";

// Returns WeekDay [Sunday/Monday/..]
export const getToday = () => {
  const today = new Date().getDay();
  return WeekDays[today];
};

// 24 - hour Format
export const isInCurrentWindow = (
  currentTime: string,
  openingTime: string,
  closingTime: string
) => {
  let currentHour = parseInt(currentTime.split(":")[0]);
  let openingHour = parseInt(openingTime.split(":")[0]);
  let closingHour = parseInt(closingTime.split(":")[0]);

  let currentMinute = parseInt(currentTime.split(":")[1]);
  let openingMinute = parseInt(openingTime.split(":")[1]);
  let closingMinute = parseInt(closingTime.split(":")[1]);

  if (currentHour >= openingHour && currentHour <= closingHour) {
    if (currentHour == openingHour) {
      if (currentMinute >= openingMinute) {
        return true;
      }
    } else if (currentHour == closingHour) {
      if (currentMinute <= closingMinute) {
        return true;
      }
    } else if (currentHour > openingHour && currentHour < closingHour) {
      return true;
    }
  }

  return false;
};

export const getHoursUntillClosing = (
  openingWindowTime: string,
  closingWindowTime: string
) => {
  let openingHour = parseInt(openingWindowTime.split(":")[0]);
  let closingHour = parseInt(closingWindowTime.split(":")[0]);
  let hours: string[] = [];

  for (let i = openingHour; i <= closingHour; i++) {
    if (i.toString().length === 1) {
      hours.push(`0${i}`);
    } else {
      hours.push(i.toString());
    }
  }

  // const closingMeridian = closingHour < 12 ? "AM" : "PM";
  // closingHour = closingHour > 12 ? closingHour - 12 : closingHour;

  // let amOrPm = openingHour < 12 ? "AM" : "PM";

  // let d = new Date();
  // let minute = d.getMinutes();

  // let hour = openingHour < 12 ? openingHour : openingHour - 12;

  // if (amOrPm == "AM") {
  //   // AM
  //   for (let i = hour; i <= 12; i++) {
  //     if (i.toString().length === 1) {
  //       hours.push(`0${i}`);
  //     } else {
  //       hours.push(i.toString());
  //     }
  //   }

  //   for (let i = 1; i <= closingHour; i++) {
  //     if (i.toString().length === 1) {
  //       if (!hours.includes(`0${i}`)) {
  //         hours.push(`0${i}`);
  //       }
  //     } else {
  //       if (!hours.includes(i.toString())) {
  //         hours.push(i.toString());
  //       }
  //     }
  //   }
  // } else if (
  //   (amOrPm == "PM" && closingMeridian == "PM") ||
  //   (amOrPm == "AM" && closingMeridian == "AM")
  // ) {
  //   for (let i = hour; i < closingHour; i++) {
  //     if (i.toString().length === 1) {
  //       hours.push(`0${i}`);
  //     } else {
  //       hours.push(i.toString());
  //     }
  //   }
  // }

  return hours;
};

export const getMinutesUntillClosing = (
  openingMinute: number,
  closingMinute: number,
  interval: number
) => {
  // let closingHour = parseInt(closingWindowTime.split(":")[0]);
  // // let openingMinute = parseInt(openingTime.split(":")[1]);
  // let closingMinute = parseInt(closingWindowTime.split(":")[1]);
  // let closingMinute = 60;
  let minutes: string[] = [];

  for (let i = openingMinute; i < closingMinute; i = i + interval) {
    if (i < 10) {
      minutes.push(`0${i}`);
    } else {
      minutes.push(`${i}`);
    }
  }

  if (minutes.length == 0) {
    minutes.push("00");
  }

  return minutes;
};

export const getServiceWindowHourIndex = (
  workingHours: WorkingHours[],
  selectedHour: number
) => {
  let hourIndex = -1;
  workingHours.map((workingHour, index: number) => {
    let openingHour = parseInt(workingHour.openingTime.split(":")[0]);
    let closingHour = parseInt(workingHour.closingTime.split(":")[0]);

    if (selectedHour >= openingHour && selectedHour <= closingHour) {
      hourIndex = index;
    }
  });
  return hourIndex;
};

export const get12HoursTime = (timeString: string) => {
  if (timeString && timeString.split(":").length == 3) {
    let hours = timeString.split(":")[0];
    let mins = timeString.split(":")[1];
    let median = "";
    if (parseInt(hours) >= 12) {
      hours = parseInt(hours) - 12 + "";
      median = "PM";
    } else {
      median = "AM";
    }
    return hours.length == 1
      ? "0" + hours + ":" + mins + " " + median
      : hours + ":" + mins + " " + median;
  } else {
    return "";
  }
};

export const getClosingWindowTime = (workingHours: WorkingHours[]) => {
  let closingWindowTime = "";
  if (workingHours && workingHours.length > 0) {
    let currentTime = new Date().toString().split(" ")[4];

    let todayWorkingHours: WorkingHours[] = [];

    // All Days Same Working Hours
    if (workingHours[0].weekday == "All") {
      // Get Todays working Hours
      todayWorkingHours = workingHours.slice();
    } else {
      // Get Todays working Hours
      let todayWeekDay = getToday();
      todayWorkingHours = workingHours.filter(
        (workingHour) => workingHour.weekday == todayWeekDay
      );
    }

    // If Today has Working Hours
    if (todayWorkingHours.length > 0) {
      // Find Working Hour Window for Today
      let workingHourWindowIndex = todayWorkingHours.findIndex(
        (todayWorkingHour) =>
          isInCurrentWindow(
            currentTime,
            todayWorkingHour.openingTime,
            todayWorkingHour.closingTime
          )
      );


      // Working Hour Window Not Available
      if (workingHourWindowIndex == -1) {
        closingWindowTime = "00:00:00";
      } else {
        // Working Hour Window  Available
        closingWindowTime =
          todayWorkingHours[workingHourWindowIndex].closingTime;
      }
    } else {
      closingWindowTime = "00:00:00";
    }
  } else {
    closingWindowTime = "00:00:00";
  }
  return closingWindowTime;
};

export const getAllServiceWindowHours = (
  workingHours: WorkingHours[],
  weekday: number
) => {
  let dayWorkingHours: WorkingHours[] = [];

  if (workingHours && workingHours.length > 0) {
    if (workingHours[0].weekday == "All") {
      // For All Days
      dayWorkingHours = workingHours.slice();
    } else {
      // Get Specific Day
      dayWorkingHours = workingHours.filter(
        (workingHour) => +workingHour.weekday == weekday
      );
    }
  }
  return dayWorkingHours;
};

export const getOpeningWindowTime = (workingHours: WorkingHours[]) => {
  let openingWindowTime = "";
  if (workingHours && workingHours.length > 0) {
    let currentTime = new Date().toString().split(" ")[4];

    let todayWorkingHours: WorkingHours[] = [];

    // All Days Same Working Hours
    if (workingHours[0].weekday == "All") {
      // Get Todays working Hours
      todayWorkingHours = workingHours.slice();
    } else {
      // Get Todays working Hours
      let todayWeekDay = getToday();
      todayWorkingHours = workingHours.filter(
        (workingHour) => workingHour.weekday == todayWeekDay
      );
    }

    // If Today has Working Hours
    if (todayWorkingHours.length > 0) {
      // Find Working Hour Window for Today
      let workingHourWindowIndex = todayWorkingHours.findIndex(
        (todayWorkingHour) =>
          isInCurrentWindow(
            currentTime,
            todayWorkingHour.openingTime,
            todayWorkingHour.closingTime
          )
      );
      // Working Hour Window Not Available
      if (workingHourWindowIndex == -1) {
        openingWindowTime = "00:00:00";
      } else {
        // Working Hour Window  Available
        openingWindowTime =
          todayWorkingHours[workingHourWindowIndex].openingTime;
      }
    } else {
      openingWindowTime = "00:00:00";
    }
  } else {
    openingWindowTime = "00:00:00";
  }
  return openingWindowTime;
};

export const getTimeString = (timeStamp: string) => {
  return timeStamp.split("T")[1].split(".")[0].replace("Z", "");
};

export const getDateString = (timeStamp: string) => {
  return timeStamp?.split("T")[0];
};

export const getLocalTimeStringFromISO = (dateISO: string) => {
  return new Date(dateISO).toLocaleTimeString();
};

// Shared function to calculate ASAP time consistently
export const getAsapTime = (
  isDeliveryOrder: boolean,
  restaurantDefaultDeliveryEta: number,
  restaurantDefaultPickupEta: number,
  restaurantTimeZone: string,
  isRestaurantClosed?: boolean,
  nextSessionStartTime?: any,
) => {
  try {
    let date = new Date()

    const restaurantDefaultEta = isDeliveryOrder
      ? restaurantDefaultDeliveryEta
      : restaurantDefaultPickupEta;


    // Use moment with timezone if available, otherwise use local time
    let baseTime=( date?moment(date):moment());
    if (restaurantTimeZone && typeof moment.tz === 'function') {
      baseTime =baseTime.tz(restaurantTimeZone);
    } 
    
    if (!baseTime) {
      baseTime = moment(); // Fallback to local time
    }

    if (isRestaurantClosed && nextSessionStartTime) {
      // nextSessionStartTime = "03:00:00"
      const [hour, minute, second] = nextSessionStartTime.split(":").map(Number);

      // Reset baseTime to restaurant's current day and nextSessionStartTime
      baseTime = moment.tz(restaurantTimeZone)
        .startOf("day")
        .add(hour, "hours")
        .add(minute, "minutes")
        .add(second || 0, "seconds");
    }
    
    if (restaurantDefaultEta) {
      baseTime = baseTime.add(restaurantDefaultEta, "minutes");
    }

    
    return baseTime.toDate();
  } catch (error) {
    console.error('Error calculating ASAP time:', error);
    // Fallback to current time
    const fallbackTime = new Date();
    if (restaurantDefaultDeliveryEta || restaurantDefaultPickupEta) {
      const eta = isDeliveryOrder ? restaurantDefaultDeliveryEta : restaurantDefaultPickupEta;
      fallbackTime.setMinutes(fallbackTime.getMinutes() + (eta || 0));
    }
    return fallbackTime;
  }
};

// Helper function to check if a date is ASAP time
export const isAsapTime = (
  date: Date,
  isDeliveryOrder: boolean,
  restaurantDefaultDeliveryEta: number,
  restaurantDefaultPickupEta: number,
  restaurantTimeZone: string,
) => {
  try {
    const asapTime = getAsapTime(
      isDeliveryOrder,
      restaurantDefaultDeliveryEta,
      restaurantDefaultPickupEta,
      restaurantTimeZone
    );
    
    // Compare hours and minutes only (ignore seconds and milliseconds)
    return (
      date.getHours() === asapTime.getHours() &&
      date.getMinutes() === asapTime.getMinutes()
    );
  } catch (error) {
    console.error('Error checking ASAP time:', error);
    return false;
  }
};


export const getCurrentTimeByTimezone = (timeZone: string) => {
  const m = moment().tz(timeZone);

  return {
    restaurantDateTime: m.format("YYYY-MM-DD HH:mm"),
    restaurantDate: m.format("YYYY-MM-DD"),
    restaurantTime: m.format("HH:mm"),
    timeZone,
    utcDate: m.clone().utc().toDate(), // backend only
  };
};

export const getCurrentTimeASAP = (
  isDeliveryOrder: boolean,
  restaurantDefaultDeliveryEta: number,
  restaurantDefaultPickupEta: number,
  timeZone: string, 
  isRestaurantClosed?: boolean,
  nextSessionStartTime?: any,) => {


    
  let m = moment().tz(timeZone);

  const restaurantDefaultEta = isDeliveryOrder
    ? restaurantDefaultDeliveryEta
    : restaurantDefaultPickupEta;

    if (isRestaurantClosed && nextSessionStartTime) {
      const [hour, minute, second] = nextSessionStartTime?.split(":")?.map(Number);
      m = m?.startOf("day")
        .add(hour, "hours")
        .add(minute, "minutes")
        .add(second || 0, "seconds");
    }

    m?.add(restaurantDefaultEta, "minutes");

  return {
    restaurantDateTime: m?.format("YYYY-MM-DD HH:mm"),
    restaurantDate: m?.format("YYYY-MM-DD"),
    restaurantTime: m?.format("HH:mm"),
    timeZone,
    utcDate: m?.clone()?.utc()?.toDate(), // backend only
  };
};
